export class PhoneNumberFormatHelper {

  public getNumbersFromString(text: string): string {
    const numbers = text?.replace(/\D/g, '').substring(0, 10);
    return numbers?.length > 0 ? numbers : "";
  }

  public formatPhone(phoneNumber: string): string {
    const phone = this.getNumbersFromString(phoneNumber);

    if (phone?.length == 0)
      return phone;

    const areaCode = phone.slice(0, 3);
    const prefix = phone.slice(3, 6);
    const line = phone.slice(6, 10);

    return `${!!areaCode ? "(" : ""}${areaCode}${!!prefix ? ") " : ""}${prefix}${!!line ? "-" : ""}${line}`;
  }

  public getPhoneTooltipWrapperText(): string {
    return "Edit/add phone number for the selected county/specialty to reflect in the Market and Prospect accordions for the selected county/specialty and in the CMS Exceptions form generated from QES for clients with the Exceptions Package. Phone numbers are not used to exclude providers."
  }
} 